'use client';

import type { ReactNode } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';
import { TextArea } from '@/app/components/form/TextArea';
import { labelStyles } from '@/app/components/form/TextArea/styles';

type MessageFieldProps = {
  id: string;
  value: string;
  maxLength: number;
  registration: UseFormRegisterReturn<'message'>;
  disabled?: boolean;
  children?: ReactNode;
};

/** Passes no `errors` to the TextArea: over the limit the design shows only the red counter and border. */
export const MessageField = ({ id, value, maxLength, registration, disabled = false, children }: MessageFieldProps) => (
  <div>
    <label htmlFor={id} className={labelStyles({ intent: 'small' })}>
      Message to the client
    </label>
    <p className="mb-1 text-body-small text-grey-700">
      You can personalize this message. Changes apply to this send only.
    </p>
    <TextArea
      id={id}
      placeholder="Write a personalized message to the client"
      size="tall"
      disableResize
      maxLength={maxLength}
      value={value}
      aria-invalid={value.length > maxLength}
      disabled={disabled}
      footer={children}
      {...registration}
    />
  </div>
);
